module.exports = __webpack_public_path__ + "static/img17-08af90e152bf29e7f5fbf84eae72c21c.jpg";